import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { CMSValueProp } from 'types'

interface Props extends CMSValueProp {
  hide?: boolean
  row?: boolean
}

export const ClubDetailValueProp = ({
  image,
  title,
  subtitle,
  hide = false,
  row = false,
}: Props) => {
  const { mediaQueries, colors, motion } = useTheme()

  return (
    <FlexBox
      className={css`
        padding-top: ${row ? 0 : '40px'};
        height: 100%;
        background-color: ${colors.uiPearlUltraLight};
        border-radius: 16px;
        overflow: hidden;
        ${mediaQueries.tabletL} {
          opacity: ${hide ? 0 : 1};
          pointer-events: ${hide ? 'none' : 'auto'};
          ${motion.transition('opacity')}
        }
      `}
      flexDirection={row ? 'row' : 'column'}
      alignItems={row ? 'stretch' : 'center'}
    >
      <img
        className={css`
          display: block;
          width: ${row ? '154px' : '100%'};
          height: ${row ? 'auto' : '256px'};
          flex-shrink: 0;
          object-fit: contain;
          object-position: bottom;
        `}
        src={image.url}
        alt={image.title}
      />
      <FlexBox
        className={css`
          padding: ${row ? '0 16px' : '24px 32px'};
          width: 100%;
          height: ${row ? '180px' : 'auto'};
          background-color: ${colors.uiPearlExtraLight};
          text-align: ${row ? 'left' : 'center'};
          flex-direction: column;
          align-items: ${row ? 'flex-start' : 'center'};
          justify-content: center;
        `}
      >
        <Text
          className={css`
            margin-bottom: 8px;
          `}
          tag="p"
          text={title}
          type="subhead"
          sizing={{ base: 'XS', mobileL: 'S' }}
          color={colors.uiGraphite}
        />
        <Text
          text={subtitle}
          type="body"
          sizing={{ base: 'S', mobileXS: 'M' }}
          color={colors.uiGraphiteLight}
        />
      </FlexBox>
    </FlexBox>
  )
}
